import { User } from "./../sdk/models/User";
import Cookies from "js-cookie";
import { CookiesKey } from "./General";
interface CookiesOption {
    expires?: Date;
    path?: string;
    domain?: string;
    secure?: boolean;
}

export const getCookie = (key: string): string | undefined => {
    return Cookies.get(key);
};
export const setCookie = (
    key: string,
    value: any,
    option?: CookiesOption | undefined,
) => {
    Cookies.set(key, value, option);
};
export const removeCookie = (key: string): void => {
    Cookies.remove(key);
};
export const cookieAvailable = (key: CookiesKey): boolean => {
    if (getCookie(key.toString()) !== undefined) {
        return true;
    } else {
        return false;
    }
};

export const createUserCookies = (User: User) => {
    var today = new Date();
    console.log(User);
    setCookie(CookiesKey.USER_COOKIE, JSON.stringify(User), {
        expires: new Date(today.setDate(today.getDate() + 1)),
    });
    setCookie(CookiesKey.JWT_TOKEN, User.token, {
        expires: new Date(today.setDate(today.getDate() + 1)),
    });
    setCookie(CookiesKey.ACCESS_ROLE, User.token, {
        expires: new Date(today.setDate(today.getDate() + 1)),
    });
};

export const createAccessRoleCookie = (role: string) => {
    var today = new Date();
    console.log(role);
    setCookie(CookiesKey.ACCESS_ROLE, role, {
        expires: new Date(today.setDate(today.getDate() + 1)),
    });
};

export const createLoginCookies = (Token: string) => {
    var today = new Date();
    setCookie(CookiesKey.JWT_TOKEN, Token, {
        expires: new Date(today.setDate(today.getDate() + 1)),
    });
};
